/** Vite bundles these local URLs; no remote asset dependency or runtime pack loading. */
export function packAssets(files: Record<string, unknown>): (path: string) => string {
  return (path) => {
    const url = files[`./${path}`];
    if (typeof url !== 'string') throw new Error(`Missing shipped theme asset: ${path}`);
    return url;
  };
}
